<div class="w-full">
    <div class="flex justify-between border-b border-b-gray-300 zuper-dialog-header">
        <h6 mat-dialog-title class="font-semibold inline-flex items-center primary-font">{{dialogTitle}}</h6>
        <div class="flex items-center mr-1">
            <span>
                <mat-slide-toggle [disableRipple]="true" id="partialApply" name="partialApply" class="form-control" [(ngModel)]="applyPartial" [ngModelOptions]="{standalone: true}" [color]="'primary'">{{'newtimeoff.apply.partial.label' | translate}}</mat-slide-toggle>
            </span>
            <span class="rounded-full flex justify-center items-center hover:bg-gray-200 h-10 w-10 p-2 ml-2 cursor-pointer" [mat-dialog-close]="{status: false}">
                <em class="ti ti-x text-xl font-bold"></em>
            </span>
        </div>
    </div>
    <!-- Time Zone Alert -->
    <div class="rounded-md bg-blue-50 m-4 mb-0 px-4 py-3 border-l-8 border-blue-700" *ngIf="timezone">
        <div class="flex items-center">
            <div class="flex-shrink-0"><em class="ti ti-alert-circle text-blue-700 text-2xl"></em></div>
            <div class="ml-3 flex-1 md:flex md:justify-between">
                <p class="text-base text-blue-700">{{'new.timeoff.time_zone.content' | translate}}
                    {{timezoneDisplayName}}, <span class="font-medium">{{timezone}}</span></p>
            </div>
        </div>
    </div>    
    <div class="flex">
    <form [formGroup]="timeoffFormGroup" class="w-full" ngNativeValidate>
        <div class="zuper-dialog-body">
            <div class="grid gap-4" [ngClass]="!applyPartial ? 'grid-cols-4' : 'grid-cols-2'">
                <mat-form-field appearance="fill" ngClass="w-full" [floatLabel]="'always'" [hideRequiredMarker]="true">
                    <mat-label class="required primary-font text-base font-semibold">{{'text.start_date' | translate}}</mat-label>
                    <input type="text" matInput id="field_value" name="field_value" class="form-control" [matDatepicker]="picker" [datePickerFormat]="dateFormat" (focus)="picker?.open()" name="from_date" formControlName="from_date" placeholder="{{'text.choose_date' | translate}}">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                    <mat-error *ngIf="timeoffFormGroup?.controls?.from_date?.invalid" class="primary-font font-semibold text-base">
                        {{'timeoff.start.date.required.error.message' | translate}}
                    </mat-error>
                </mat-form-field>
                <mat-form-field [hideRequiredMarker]="true" appearance="fill" ngClass="w-full" [floatLabel]="'always'" *ngIf="!applyPartial">
                    <mat-label class="primary-font text-base font-semibold">{{'text.start_time' | translate}}</mat-label>
                    <input matInput id="from_time_field" name="from_time_field" class="form-control" formControlName="from_time_field" placeholder="{{'text.pick_time' | translate}}"
                           [matMenuTriggerFor]="startTimeRef"
                           readonly />
                           <button type="button" [matMenuTriggerFor]="startTimeRef" mat-icon-button matSuffix>
                                <mat-icon
                                [svgIcon]="'heroicons_solid:clock'"></mat-icon>
                           </button>
                           <mat-menu #startTimeRef="matMenu">
                            <div class="flex flex-col">
                                <div class="flex justify-center">
                                    <ngx-mat-timepicker (click)="$event.stopPropagation()"
                                    formControlName="from_time_picker" 
                                    [disabled]="false"
                                    [showSpinners]="true"
                                    [stepHour]="1" [stepMinute]="15"
                                    [showSeconds]="false"
                                    [enableMeridian]="getMeridian()">
                                    </ngx-mat-timepicker>
                                </div>
                                <div class="flex justify-center">
                                    <button mat-stroked-button>
                                        <span>{{'text.ok' | translate}}</span>
                                    </button>
                                </div>
                            </div>
                        </mat-menu>
                </mat-form-field>
                <mat-form-field [hideRequiredMarker]="true" appearance="fill" ngClass="w-full" [floatLabel]="'always'">
                    <mat-label class="required primary-font text-base font-semibold">{{'text.end_date' | translate}}</mat-label>
                    <input type="text" matInput id="field_value" name="field_value" class="form-control" [min]="timeoffFormGroup?.controls?.from_date?.value" [matDatepicker]="toDatePicker" [datePickerFormat]="dateFormat" (focus)="toDatePicker?.open()" name="to_date" formControlName="to_date" placeholder="{{'text.choose_to_date' | translate}}">
                    <mat-datepicker-toggle matSuffix [for]="toDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #toDatePicker></mat-datepicker>
                    <mat-error *ngIf="timeoffFormGroup?.controls?.to_date?.invalid && timeoffFormGroup?.controls?.to_date?.touched && timeoffFormGroup.controls.to_date.hasError('required')" class="primary-font font-semibold text-base">
                        {{'timeoff.end.date.required.error.message' | translate}}
                    </mat-error>
                </mat-form-field>
                <mat-form-field [hideRequiredMarker]="true" appearance="fill" ngClass="w-full" [floatLabel]="'always'" *ngIf="!applyPartial">
                    <mat-label class="primary-font text-base font-semibold">{{'text.end_time' | translate}}</mat-label>
                    <input matInput id="to_time_field" name="to_time_field" class="form-control" formControlName="to_time_field" placeholder="{{'text.pick_time' | translate}}"
                           [matMenuTriggerFor]="endTimeRef"
                           readonly />
                           <mat-error *ngIf="timeoffFormGroup.controls.to_time_field.hasError('invalidEndTime')">{{'dispatchBoard.scheduler.reschedule.start_end_time_invalid' | translate}}</mat-error>
                           <button type="button" mat-icon-button matSuffix [matMenuTriggerFor]="endTimeRef">
                                <mat-icon
                                [svgIcon]="'heroicons_solid:clock'"></mat-icon>
                           </button>
                           <mat-menu #endTimeRef="matMenu">
                            <div class="flex flex-col">
                                <div class="flex justify-center">
                                    <ngx-mat-timepicker (click)="$event.stopPropagation()"
                                    formControlName="to_time_picker" 
                                    [disabled]="false"
                                    [showSpinners]="true"
                                    [stepHour]="1" [stepMinute]="15"
                                    [showSeconds]="false"
                                    [enableMeridian]="getMeridian()">
                                    </ngx-mat-timepicker>
                                </div>
                                <div class="flex justify-center">
                                    <button mat-stroked-button>
                                        <span>{{'text.ok' | translate}}</span>
                                    </button>
                                </div>
                            </div>
                        </mat-menu>
                </mat-form-field>
            </div>
            <div class="grid grid-cols-2 gap-4 mt-3">
                <div class="mb-2 space-y-2">
                    <mat-label class="required primary-font text-base font-semibold mb-3">{{'text.choose_user' | translate}}</mat-label>
                    <ng-select ngClass="w-full" appearance="fill" [items]="listValue$ | async" [readonly]="disableUserAndTeamPicker"
                            id="userId" 
                            name="userId" 
                            class="form-control" 
                            appendTo="body"
                            bindLabel="bindLabel"
                            bindValue="user_uid"
                            placeholder="{{'text.choose_user' | translate}}"
                            [multiple]="false"
                            [hideSelected]="true"
                            [loading]="lookupLoading"
                            typeToSearchText="{{'info.type_to_search_text' | translate}}"
                            formControlName="user"
                            [typeahead]="valueSubject$"
                            (change) = "onUserValueChange($event)"
                            >
                            <ng-template ng-label-tmp let-item="item" let-clear="clear">
                                <span class="ng-value-label">{{item.first_name || ''}} {{item.last_name || ''}} - {{item.email || ''}}</span>
                                <span class="ng-value-icon right" (click)="clear(item)">×</span>
                            </ng-template>
                            <ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
                                <span >{{item.first_name + ' ' + item.last_name}}</span>
                                <br>
                                <span class="text-md text-secondary">{{ item.email}}</span>
                            </ng-template>
                    </ng-select>
                    <mat-error *ngIf="timeoffFormGroup?.controls?.user?.invalid && timeoffFormGroup?.controls?.user?.touched" class="primary-font font-semibold text-base">
                        {{'text.user_required' | translate}}
                    </mat-error>
                </div>
                <div class="mb-2 space-y-2 mt-1">
                    <mat-form-field appearance="fill" class="w-full mat-form-field-should-float" [hideRequiredMarker]="true" [floatLabel]="'always'">
                        <mat-label class="primary-font text-base font-semibold">{{'text.choose_team' | translate}}</mat-label>
                        <mat-select formControlName="team" [disabled]="disableUserAndTeamPicker"
                            (keydown.escape)="$event.stopPropagation()" 
                            id="team" 
                            name="team" 
                            class="form-control"
                            placeholder="{{'text.choose_team' | translate}}">
                            <mat-option *ngFor="let team of teams" [value]="team.team_uid">{{team.team_name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="w-full">
                    <mat-form-field appearance="fill" class="w-full mat-form-field-should-float -mt-1" [hideRequiredMarker]="true" [floatLabel]="'always'">
                      <mat-label class="required primary-font font-semibold">{{'text.Reason' | translate}}</mat-label>
                      <mat-select id="reason" name="reason" class="form-control" formControlName="reason" placeholder="{{'newtimeoff.reason.placeholder' | translate}}" (selectionChange)="onSelectionChange($event)">
                        <mat-optgroup *ngFor="let group of reasonOptions" [label]="group.name">
                            <mat-option *ngFor="let reason of group.reasons" [value]="reason.value">
                                {{reason.key | translate}}
                            </mat-option>
                        </mat-optgroup>
                      </mat-select>
                      <mat-error *ngIf="timeoffFormGroup?.controls?.reason?.invalid" class="primary-font font-semibold text-base">
                        {{'newtimeoff.reason.required.text' | translate}}
                      </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="w-full mt-5">
                <mat-form-field class="example-full-width use-default-mat-height" appearance="fill" ngClass="w-full" [hideRequiredMarker]="true" [floatLabel]="'always'">
                    <mat-label class="primary-font font-semibold">{{'text.remarks' | translate}}</mat-label>
                    <textarea type="text" matInput id="remarks" name="remarks" class="form-control" formControlName="remarks" autocomplete="off" placeholder="{{'text.enter_remarks' | translate}}"></textarea>
                </mat-form-field>
            </div>
        </div>
        <div class="flex justify-between border-t border-gray-300 zuper-dialog-footer">
            <div class="inline-flex items-center">
                <mat-checkbox [disableRipple]="true" id="notifyUser" name="notifyUser" class="form-control" formControlName="notify_user" [color]="'primary'">
                    {{'newtimeoff.notify.user.label' | translate}}
                </mat-checkbox>
            </div>
            <div class="space-x-3">
                <button mat-stroked-button [mat-dialog-close]="{status: false}" class="btn-small px-6 items-center py-2 border b-1 border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-600 bg-white hover:bg-gray-50 focus:outline-none" type="button">{{'cancel.text' | translate}}</button>
                <button mat-stroked-button class="btn-small bg-primary px-6 items-center py-2 border b-1 border-gray-300 shadow-sm text-white text-base font-medium rounded-md text-white-600 focus:outline-none" (click)="onformSubmit()">{{'text.submit' | translate}}</button>
            </div>
        </div>
    </form>
    </div>
</div>